import React, {useState} from "react";
import {totalProfitBySellingReports} from "../../services/serviceReports";
import {Card, Col, Row, Space, Table, Collapse} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import Filter from "../filterWrapper/Filter";
import TotalProfitFilter from "./TotalProfitFilter";
import PieChart from "../charts/PieChart";
import BarChart from "../charts/BarChart";


const {Panel} = Collapse;
const setTableRowKeys = (r, index) => index

const TotalProfitBySellingReports = () => {
    const [tableData, setTableData] = useState({})
    const [openFilter, setOpenFilter] = useState(false)
    const [currenciesData, setCurrenciesData] = useState([])
    const [customerChartData, setCustomerChartData] = useState({})
    const [supplierChartData, setSupplierChartData] = useState({})

    const clearTable = () => {
        setTableData([])
        setCurrenciesData([])
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)


    const customerColumns = [
        {title: 'Müşteri', dataIndex: 'cn'},
        {
            title: 'Toplam', dataIndex: 't',
            render: (t, r) =>
                <p>{new Intl.NumberFormat().format(t)} <span className={'font-bold'}>{r.c}</span></p>
        }
    ]
    const brandColumns = [
        {title: 'Marka', dataIndex: 'b'},
        {
            title: 'Satış Toplamı', dataIndex: 't',
            render: (t, r) =>
                <p>{new Intl.NumberFormat().format(t)} <span className={'font-bold'}>{r.c}</span></p>
        },
        {
            title: 'Satın Alma Toplamı', dataIndex: 'lt',
            render: (t) =>
                <p>{new Intl.NumberFormat().format(t)}</p>
        }
    ]
    const supplierColumns = [
        {title: 'Tedarikçi', dataIndex: 's'},
        {
            title: 'Toplam', dataIndex: 't',
            render: (t, r) =>
                <p>{new Intl.NumberFormat().format(t)} <span className={'font-bold'}>{r.c}</span></p>
        }
    ]
    const totalColumns = [
        {title: 'EUR', dataIndex: 'EUR', render: (t) => new Intl.NumberFormat().format(t)},
        {title: 'USD', dataIndex: 'USD', render: (t) => new Intl.NumberFormat().format(t)},
        {title: 'TRY', dataIndex: 'TRY', render: (t) => new Intl.NumberFormat().format(t)},
    ]

    const handleTotals = (list) => {
        const currencyObj = {
            EUR: [],
            USD: [],
            TRY: []
        }

        list.brandReportDTOS.map(item => {
            if (item.c && item.t) {
                currencyObj[item.c.toUpperCase()].push(item.t)
            }
        })

        const [eur, usd, turkishLira] = Object.values(currencyObj).map(currencies => currencies.reduce((a, b) => a + b, 0))
        currencyObj.EUR = eur;
        currencyObj.USD = usd;
        currencyObj.TRY = turkishLira;

        setCurrenciesData([currencyObj])
    }

    const handleFilter = (...filterData) => {
        totalProfitBySellingReports(filterData[0])
            .then(({data}) => {
                handleCustomerChartData(data.customerReportDTOS)
                handleSupplierChartData(data.supplierReportDTOS)
                setTableData(data)
                handleTotals(data)
            })

        return new Promise((resolve, reject) => {
            resolve(true)
            reject(false)
        })
    }

    const handleCustomerChartData = (dataSet = []) => {
        if (dataSet.length) {
            const currencyObj = clusterData(dataSet)
            Object.keys(currencyObj).map(key => currencyObj[key].sort((crr, acc) => acc.value - crr.value))
            setCustomerChartData(currencyObj)
        }
    }

    const handleSupplierChartData = (dataSet = []) => {
        if (dataSet.length) {
            const currencyObj = clusterData(dataSet)
            Object.keys(currencyObj).map(key => currencyObj[key].sort((crr, acc) => acc.value - crr.value))
            setSupplierChartData(currencyObj)
        }
    }


    const clusterData = (dataSet) => {
        const currObj = {
            'EUR': [],
            'USD': [],
            'TRY': []
        }
        dataSet.forEach(data => data.c ? currObj[data.c].push({value: data.t, key: data.cn || data.s}) : null)

        return currObj
    }

    return (
        <React.Fragment>
            <Card
                title={'Satış Bazlı Ciro Raporları'}
            >
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined/></div>
                </Row>
                <Collapse accordion defaultActiveKey={['0']}>
                    <Panel header={'Toplam ( Marka )'} key={'0'}>
                        <Row justify={'space-between'} align={'middle'}>
                            <Col span={12}>
                                <Table rowKey={setTableRowKeys} columns={totalColumns} dataSource={currenciesData}/>
                            </Col>
                            {
                                currenciesData && currenciesData.length ?
                                    <Col span={10}>
                                        <PieChart
                                            xAxis={Object.keys(currenciesData[0]).map(key => key)}
                                            yAxis={Object.values(currenciesData[0]).map(val => val.toFixed(2))}
                                        />
                                    </Col> : null
                            }
                        </Row>
                    </Panel>
                    <Panel header={'Marka'} key={'1'}>
                        <Table rowKey={setTableRowKeys} columns={brandColumns} dataSource={tableData.brandReportDTOS}/>
                    </Panel>
                    <Panel header={'Müşteri'} key={'2'}>
                        {
                            Object.keys(customerChartData).length ?
                                <Row gutter={24}>
                                    {
                                        customerChartData['EUR'].length ?
                                            <Col span={12}>
                                                <BarChart
                                                    xAxis={customerChartData['EUR'].slice(0, 10).map(item => item.key.slice(0, 15))}
                                                    yAxis={customerChartData['EUR'].slice(0, 10).map(item => item.value)}
                                                    label={'EUR'}
                                                    xSet={'Müşteri'}
                                                    ySet={'Miktar'}
                                                />
                                            </Col>
                                            : null
                                    }
                                    {
                                        customerChartData['USD'].length ?
                                            <Col span={12}>
                                                <BarChart
                                                    xAxis={customerChartData['USD'].slice(0, 10).map(item => item.key.slice(0, 15))}
                                                    yAxis={customerChartData['USD'].slice(0, 10).map(item => item.value)}
                                                    label={'USD'}
                                                />
                                            </Col>
                                            : null
                                    }
                                    {
                                        customerChartData['TRY'].length ?
                                            <Col span={12}>
                                                <BarChart
                                                    xAxis={customerChartData['TRY'].slice(0, 10).map(item => item.key.slice(0, 15))}
                                                    yAxis={customerChartData['TRY'].slice(0, 10).map(item => item.value)}
                                                    label={'TRY'}
                                                />
                                            </Col>
                                            : null
                                    }
                                </Row>
                                : null
                        }
                        <Table rowKey={setTableRowKeys} columns={customerColumns}
                               dataSource={tableData.customerReportDTOS}/>
                    </Panel>
                    <Panel header={'Tedarikçi'} key={'3'}>
                        {
                            Object.keys(supplierChartData).length ?
                                <Row gutter={24}>
                                    {
                                        supplierChartData['EUR'].length ?
                                            <Col span={8}>
                                                <BarChart
                                                    xAxis={supplierChartData['EUR'].slice(0, 5).map(item => item.key.slice(0, 15))}
                                                    yAxis={supplierChartData['EUR'].slice(0, 5).map(item => item.value)}
                                                    label={'EUR'}
                                                    xSet={'Tedarikçi'}
                                                    ySet={'Miktar'}
                                                />
                                            </Col>
                                            : null
                                    }
                                    {
                                        supplierChartData['USD'].length ?
                                            <Col span={8}>
                                                <BarChart
                                                    xAxis={supplierChartData['USD'].slice(0, 5).map(item => item.key.slice(0, 15))}
                                                    yAxis={supplierChartData['USD'].slice(0, 5).map(item => item.value)}
                                                    label={'USD'}
                                                />
                                            </Col>
                                            : null
                                    }
                                    {
                                        supplierChartData['TRY'].length ?
                                            <Col span={8}>
                                                <BarChart
                                                    xAxis={supplierChartData['TRY'].slice(0, 5).map(item => item.key.slice(0, 15))}
                                                    yAxis={supplierChartData['TRY'].slice(0, 5).map(item => item.value)}
                                                    label={'TRY'}
                                                />
                                            </Col>
                                            : null
                                    }
                                </Row>
                                : null
                        }
                        <Table rowKey={setTableRowKeys} columns={supplierColumns}
                               dataSource={tableData.supplierReportDTOS}/>
                    </Panel>
                </Collapse>
            </Card>

            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Ciro Raporlama'}
                    handler={handleFilter}
                    resetHandler={clearTable}
                >
                    <TotalProfitFilter/>
                </Filter>
            }

        </React.Fragment>
    )
}
export default TotalProfitBySellingReports